import {
  Button,
  ListContainer,
  ListContext,
  PAGE_DEFAULT,
  PAGE_SIZE_UNLIMITED,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  formatDate,
  formatSchoolYear,
  pn,
} from "@compass/core";

import { Permission, PermissionAction, StudentDiplomaListDto, StudentDiplomaListFilter } from "generated/openApi";
import { useList, useRouter } from "hooks";
import { studentDiplomaPageRoute } from "pages/students/student-diplomas/StudentDiplomaPage/StudentDiplomaPage";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const Diplomas = (props: { initialLoad: boolean; studentId: number }) => {
  const ROOT_PERMISSION: Permission = Permission.StudentDiploma;
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();

  const [listFilter, setListFilter] = useState<StudentDiplomaListFilter>({
    diplomaFilter: { studentId: props.studentId },
    page: PAGE_DEFAULT,
    pageSize: PAGE_SIZE_UNLIMITED,
    sortObjects: [{ property: pn<StudentDiplomaListDto>("schoolYear"), isDesc: true }],
  });
  const [listItems, setListItems] = useState<StudentDiplomaListDto[]>([]);

  const { tableContainerRef, loadList } = useList({
    listFilter: listFilter,
    setListFilter: setListFilter,
    fetchList: (listFilter) => {
      ApiService.studentDiplomas.getList(listFilter).then((response) => {
        setListItems(response);
      });
    },
  });

  useEffect(() => {
    if (props.initialLoad) {
      loadList(listFilter);
    }
  }, [props.initialLoad]);

  return (
    <>
      <ListContainer
        fullHeight
        header={
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="inherit">Diplomas</Typography>

            <Stack direction="row" alignItems="center" spacing="sm">
              {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
                <Button
                  variant="text"
                  onClick={() =>
                    navigate({
                      pathname: studentDiplomaPageRoute.getPath({ id: 0, crudMode: "edit", screenType: "dialog" }),
                      search: studentDiplomaPageRoute.getOptionalParams?.({
                        studentId: props.studentId,
                      }),
                    })
                  }
                  sx={{ minWidth: "auto" }}
                >
                  + New
                </Button>
              )}
            </Stack>
          </Stack>
        }
        tableContainer={
          <TableContainer ref={tableContainerRef}>
            <Table stickyHeader>
              <TableBody>
                {listItems.map((listItem) => (
                  <TableRow
                    key={listItem.id}
                    onClick={() =>
                      navigate({
                        pathname: studentDiplomaPageRoute.getPath({
                          id: listItem.id,
                          crudMode: "view",
                          screenType: "dialog",
                        }),
                      })
                    }
                  >
                    <TableCell>{formatSchoolYear(listItem.schoolYear)}</TableCell>
                    <TableCell>{formatDate(listItem.date)}</TableCell>
                    <TableCell>{listItem.diplomaType}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      />

      <ListContext.Provider value={{ loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }) }}>
        {matchTemplatePath(studentDiplomaPageRoute.templatePath) && <Outlet />}
      </ListContext.Provider>
    </>
  );
};
